import {memo} from "react";
import {
	InputField
} from "~/components/Forms";
import {Button} from "~/components";
import {Controller, useForm} from "react-hook-form";

function CustomerSearch({filter, onSearchChange}) {

	const {control, handleSubmit, formState: { errors }} = useForm({defaultValues: {}});

	const onSubmit = (data) => {
		if (!onSearchChange) return;
		const newFilter = {
			...filter,
			phone: data.phone,
			page: 1,
		};
		onSearchChange(newFilter);
	}

	return (
		<form className="form form-search d-flex gap-1" autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
			<Controller control={control} name="phone" render={({field}) => (
				<InputField placeholder="Số điện thoại" defaultValue={filter?.phone} errors={errors} {...field} />
			)}/>
			<Button background primary>Áp dụng</Button>
		</form>
	)
}

export default memo(CustomerSearch);